"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveOrdersForClaimingOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveOrdersForClaimingOptions = class RetrieveOrdersForClaimingOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveOrdersForClaimingOptions = RetrieveOrdersForClaimingOptions;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveOrdersForClaimingOptions.prototype, "maxPrice", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrieveOrdersForClaimingOptions.prototype, "createdAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrieveOrdersForClaimingOptions.prototype, "createdAtTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrieveOrdersForClaimingOptions.prototype, "departureAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    __metadata("design:type", Date)
], RetrieveOrdersForClaimingOptions.prototype, "departureAtTo", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveOrdersForClaimingOptions.prototype, "originCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveOrdersForClaimingOptions.prototype, "destinationCountryIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => Number(item)))),
    __metadata("design:type", Array)
], RetrieveOrdersForClaimingOptions.prototype, "statusIn", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveOrdersForClaimingOptions.prototype, "type", void 0);
exports.RetrieveOrdersForClaimingOptions = RetrieveOrdersForClaimingOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveOrdersForClaimingOptions);
//# sourceMappingURL=RetrieveOrdersForClaimingOptions.js.map